module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/handsome_1x.1048118.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/handsome_1x.png
// module id = dDBp
// module chunks = 41